// extracted by mini-css-extract-plugin
module.exports = {"root":"notification__root--Jg02R"};